import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import OuvidoriaService from '../../../services/ouvidoria';
import { Link } from 'react-router-dom';


const Ouvidoria = () => {
    const [nome, setNome] = useState("");
    const [endereco, setEndereco] = useState("");
    const [telefone, setTelefone] = useState("");
    const [email, setEmail] = useState("");
    const [descricao, setDescricao] = useState("");
    const [sexo, setSexo] = useState("");
    const [cidade, setCidade] = useState("");
    const [esic, setEsic] = useState(false);
    const [error, setError] = useState([]);
    const [arquivo, setArquivo] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [id, setId] = useState("");

    const handleUpload = (e) => setArquivo(e.target.files[0]);


    const montaForm = async () => {
        const ouvidoria = new FormData();
        ouvidoria.append("nome", nome)
        ouvidoria.append("endereco", endereco)
        ouvidoria.append("telefone", telefone)
        ouvidoria.append("email", email)
        ouvidoria.append("descricao", descricao)
        ouvidoria.append("esic", esic)
        ouvidoria.append("sexo", sexo)
        ouvidoria.append("cidade", cidade)
        ouvidoria.append("arquivo", arquivo);
        return ouvidoria
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const ouvidoria = await OuvidoriaService.cadastro(dados)
            setId(ouvidoria.data["_id"])
            setSucesso(true)
            setError(false)
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("")
        setEndereco("")
        setTelefone("")
        setSexo("")
        setCidade("")
        setDescricao("")
        setEmail("")
        setArquivo("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Alert variant='warning'>Por favor, abaixo selecione a <strong>opção correta com atenção!</strong> <br />
                        Tem um problema na sua rua ou bairro? Alguma crítica ou sugestão? Alguma solicitação de serviço público? Selecione a opção: Fazer uma solicitação à plataforma Administra Cidadão. <br /><br />
                        Deseja ter acesso a alguma informação que não encontrou no site ou no Portal da Transparência ou qualquer informação relacionada à Prefeitura Municipal de Macuco, selecione a opção: Fazer um pedido de acesso à informação (E-SIC).<br />
                        A correta seleção da opção agiliza o atendimento da sua demanda, pois será direcionada para o setor correto desde o princípio.
                    </Alert>
                    <Row xs={1} lg={3}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="O que deseja?">
                                <FloatingLabel
                                    label="O que deseja?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="O que deseja?"
                                        name="esic"
                                        onChange={e => setEsic(e.target.value)}
                                    >
                                        <option>SELECIONE UMA OPÇÃO</option>
                                        <option value="E-sic">Fazer um pedido de acesso à informação (E-SIC) - Lei nº 12.527</option>
                                        <option value="Administra Cidadão">Fazer uma solicitação à plataforma Administra Cidadão - Decreto Municipal nº1392/2022</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>

                        {esic === "E-sic" ?
                            <Fragment>
                                <Col>
                                    <Form.Group className="mb-3" controlId="Nome">
                                        <FloatingLabel
                                            label="Nome"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="nome"
                                                value={nome}
                                                onChange={e => setNome(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="Endereço">
                                        <FloatingLabel
                                            label="Endereço"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="endereco"
                                                value={endereco}
                                                onChange={e => setEndereco(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="Cidade">
                                        <FloatingLabel
                                            label="Cidade"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="cidade"
                                                value={cidade}
                                                onChange={e => setCidade(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="Gênero">
                                        <FloatingLabel
                                            label="Gênero"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="sexo"
                                                name="sexo"
                                                onChange={e => setSexo(e.target.value)}
                                            >
                                                <option value="Não informado">Prefiro não informar</option>
                                                <option value="Masculino">Masculino</option>
                                                <option value="Feminino">Feminino</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="E-mail">
                                        <FloatingLabel
                                            label="E-mail"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="email"
                                                value={email}
                                                onChange={e => setEmail(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="WhatsApp">
                                        <FloatingLabel
                                            label="WhatsApp (com DDD, apenas números)"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="number"
                                                name="telefone"
                                                placeholder='Exemplo: 22999999999'
                                                value={telefone}
                                                onChange={e => setTelefone(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="Descrição">
                                        <FloatingLabel
                                            label="Informação solicitada"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="descricao"
                                                value={descricao}
                                                onChange={e => setDescricao(e.target.value)}
                                                as="textarea"
                                                rows={5}
                                            />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col> <br /><br />
                            </Fragment>
                            : null}
                        {esic === "Administra Cidadão" ? <Fragment>
                            <Col>
                                <Form.Group className="mb-3" controlId="Nome">
                                    <FloatingLabel
                                        label="Nome"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            required
                                            type="text"
                                            name="nome"
                                            value={nome}
                                            onChange={e => setNome(e.target.value)} />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="Endereço">
                                    <FloatingLabel
                                        label="Endereço"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            required
                                            type="text"
                                            name="endereco"
                                            value={endereco}
                                            onChange={e => setEndereco(e.target.value)} />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                             <Col>
                                    <Form.Group className="mb-3" controlId="Cidade">
                                        <FloatingLabel
                                            label="Cidade"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="cidade"
                                                value={cidade}
                                                onChange={e => setCidade(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="sexo">
                                        <FloatingLabel
                                            label="Sexo"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="sexo"
                                                name="sexo"
                                                onChange={e => setSexo(e.target.value)}
                                            >
                                                <option value="Não informado">Prefiro não informar</option>
                                                <option value="Masculino">Masculino</option>
                                                <option value="Feminino">Feminino</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="E-mail">
                                    <FloatingLabel
                                        label="E-mail"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            required
                                            type="text"
                                            name="email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)} />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="WhatsApp">
                                    <FloatingLabel
                                        label="WhatsApp (com DDD, apenas números)"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            required
                                            type="number"
                                            name="telefone"
                                            placeholder='Exemplo: 22999999999'
                                            value={telefone}
                                            onChange={e => setTelefone(e.target.value)} />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={12}>
                                <Form.Group className="mb-3" controlId="Descrição">
                                    <FloatingLabel
                                        label="Descrição do Problema"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            required
                                            type="text"
                                            name="descricao"
                                            value={descricao}
                                            onChange={e => setDescricao(e.target.value)}
                                            as="textarea"
                                            rows={5}
                                        />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                            <Col lg={12}>
                                <Form.Group className="mb-3" controlId="arquivo">
                                    <Form.Label>Foto</Form.Label>
                                    <Form.Control
                                        type="file"
                                        name="arquivo"
                                        onChange={handleUpload}
                                        accept="image/*"

                                    />
                                </Form.Group>
                            </Col><br /><br />
                        </Fragment> : null}

                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/ouvidoria'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Requisição cadastrada com sucesso! Por favor, anote o número dela para futuras consultas: {id}</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <br /><br />
                <Link to={'/ouvidoria'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Ouvidoria;